export const getters = {
  getPatientDataMap: (state) => {
    return state.patientDataMap;
  },
  getViewCategories: (state) => {
    return state.viewCategories;
  },
  getSelectedCategoryDefinitions: (state) => {
    return state.selectedCategoryDefinitions;
  },
  getFilteredCategoryDefinitions: (state) => {
    return state.filteredCategoryDefinitions;
  },
  getViewAlert: (state) => {
    return state.viewAlert;
  },
  getIndex: (state) => {
    return state.index;
  },
  getIndexes: (state) => {
    return state.indexes;
  },
  getLoadingStatus: (state) => {
    return state.loading;
  },
  getAPIData: (state) => {
    return state.apiData;
  },
  getPatientData: (state) => {
    return state.patientData;
  },
  getParentId: (state) => {
    return state.parentId;
  },
  getAllCategoryDefinitions: (state) => {
    return state.all_categories;
  },
  getAllCategoryDefinitionsById: (state) => {
    return state.allCategoryDefinitionsById;
  },
  getAttributeValue: (state) => (keystr) => {
    let keys = keystr.split('.');
    let obj = state.categories;
    let val = '';
    for (var i = 0; i < keys.length; i++) {
      let k = keys[i];
      if (k in obj) {
        obj = obj[k];
      } else {
        return val;
      }
    }
    val = obj.value;
    return val;
  },
  getAttributeDisplayName: (state) => (keystr) => {
    let keys = keystr.split('.');
    let obj = state.categories;
    let val = '';
    for (var i = 0; i < keys.length; i++) {
      let k = keys[i];
      if (k in obj) {
        obj = obj[k];
      } else {
        return val;
      }
    }
    val = obj.display_name;
    return val;
  },
};
